import { PAGE_PATH_SHAREABLE_WISHLIST } from '../../constants'
import { useStore } from '../../providers/store'
import { useWishList } from './useWishList'

export const useShareableWishListUrl = () => {
	const { uid } = useWishList()
	const { uri } = useStore()

	return {
		url: uid ? uri + PAGE_PATH_SHAREABLE_WISHLIST + uid : null,
	}
}
